import {
  APIgetNotifications,
  APIgetNotification,
  APImarkNotificationRead,
  APImarkAllNotificationsRead,
  APImarkNotificationUnread,
  APIdeleteNotification,
} from '../api/Notifications';

export const SET_NOTIFICATIONS_LOADING = 'SET_NOTIFICATIONS_LOADING';
export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS';
export const SET_NOTIFICATIONS_TOTAL = 'SET_NOTIFICATIONS_TOTAL';
export const SET_NOTIFICATIONS_UNREAD = 'SET_NOTIFICATIONS_UNREAD';
export const SET_NOTIFICATION_STATUS = 'SET_NOTIFICATION_STATUS';
export const SET_ALL_NOTIFICATIONS_STATUS = 'SET_ALL_NOTIFICATIONS_STATUS';
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';

export const setNotificationsLoading = loading => ({
  type: SET_NOTIFICATIONS_LOADING,
  loading,
});

export const getNotifications = notifications => ({
  type: GET_NOTIFICATIONS,
  notifications,
});

export const setNotificationsTotal = total => ({
  type: SET_NOTIFICATIONS_TOTAL,
  total,
});

export const setNotificationsUnread = unread => ({
  type: SET_NOTIFICATIONS_UNREAD,
  unread,
});

export const setNotificationStatus = (notificationId, unread) => ({
  type: SET_NOTIFICATION_STATUS,
  notificationId,
  unread,
});

export const setAllNotificationsStatus = (unread) => ({
  type: SET_ALL_NOTIFICATIONS_STATUS,
  unread,
});

export const addNotification = notification => ({
  type: ADD_NOTIFICATION,
  notification,
});

export const removeNotification = notificationId => ({
  type: REMOVE_NOTIFICATION,
  notificationId,
});

export const fetchNotifications = (params) => (dispatch, getState) => {
  const {
    notifications,
    total,
    loading,
  } = getState().Notifications;

  if (loading) {
    return false;
  }

  const offset = notifications.length;
  if (total <= offset && (offset > 0 || (offset === 0 && total === 0))) {
    return false;
  }

  dispatch(setNotificationsLoading(true));
  return APIgetNotifications({ ...params, offset })
    .then((response) => {
      const { data } = response;
      if (data) {
        dispatch(getNotifications(data.data));
        dispatch(setNotificationsTotal(data.meta.total));
        dispatch(setNotificationsUnread(data.meta.unread));
        dispatch(setNotificationsLoading(false));
        return data;
      }
      return response;
    })
    .catch(error => (error));
};

export const fetchNotification = (notificationId) => (dispatch) => (
  APIgetNotification(notificationId).then((response) => (
    dispatch(addNotification(response.data))
  ))
);

export const markNotificationAsRead = (notificationId) => (dispatch, getState) => {
  APImarkNotificationRead(notificationId);
  dispatch(setNotificationsUnread(getState().Notifications.unread - 1));
  return dispatch(setNotificationStatus(notificationId, false));
};

export const markAllNotificationsAsRead = () => (dispatch) => {
  APImarkAllNotificationsRead();
  dispatch(setNotificationsUnread(0));
  return dispatch(setAllNotificationsStatus(false));
};

export const markNotificationAsUnread = (notificationId) => (dispatch, getState) => {
  APImarkNotificationUnread(notificationId);
  dispatch(setNotificationsUnread(getState().Notifications.unread + 1));
  return dispatch(setNotificationStatus(notificationId, true));
};

export const deleteNotification = (notificationId) => (dispatch, getState) => {
  APIdeleteNotification(notificationId);
  dispatch(setNotificationsTotal(getState().Notifications.total - 1));
  return dispatch(removeNotification(notificationId));
};
